import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { RequestContextType } from "@utils/api-config/RequestContext";
import { createApiRequestOptions } from "@utils/api-config/createApiRequestOptions";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

export class PaymentManagerApiService {
	static baseUrl(context: ApiRequestContextData | null) {
		return `${WEBPACK_BASE_ADDRESS}${context?.agencyKey}/payment-manager`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		appHeaders["Accept" as keyof HeadersInit] = "application/json";

		return appHeaders;
	};

	static async cancelWithdrawalTransaction(
		transactionId: string,
		options = createApiRequestOptions(RequestContextType.Online)
	): Promise<any> {
		const context = getApiRequestContext(options);
		return await httpClient.put(
			`${this.baseUrl(context)}/cancel/${transactionId}`,
			null,
			this.getRequestHeaders(context),
			{ responseType: "raw" }
		);
	}
}
